<template>
  <div class="flex overflow-hidde">
    <div class="h-full w-full relative overflow-y-auto">
      <main>
        <div
          class="w-full grid grid-cols-1 xl:grid-cols-2 2xl:grid-cols-3 gap-4 grid-flow-row-dense"
        ></div>
      </main>
    </div>
  </div>
</template>

<script>
export default {
  name: "DashboardAgroExporter",
  methods: {
    checkIfUserIsAuthorizedInRole(role, permission) {
      return this.checkIfUserIsAuthorized(role, permission, "producer");
    }
  }
};
</script>
